import { RecipesNavigationActions } from '../components/recipes/router/RecipeNavActions';
import { ShoppingListsNavActions } from '../components/shoppinglists/router/NavigationActions';

export const NavActions = {
  goToRecipesPage: RecipesNavigationActions.goToRecipesPage,
  goToListsPage: ShoppingListsNavActions.gotoShoppingListPage,
  openMenu: (isRecipesPage: boolean, open: boolean) =>
    isRecipesPage ? RecipesNavigationActions.openMenu(open) : ShoppingListsNavActions.openMenu(open)
};
